import { ComponentProps } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import CollectionRow from "./CollectionRow";

/**
 * A collection row wired into its level's DndContext.
 *
 * Separate from CollectionRow because `useSortable` is a hook: the rows that
 * cannot be dragged — someone else's space, or a search result, which is flat
 * and so belongs to no level — have to render without calling it at all rather
 * than with it switched off.
 *
 * The sortable id is the collection id, not the node key: within one level a
 * collection appears once (buildCollectionTree folds the two kinds of parent
 * edge into a single one), and the level is the whole of what gets dragged.
 */
export default function SortableCollectionRow(
  props: Omit<ComponentProps<typeof CollectionRow>, "sortable">,
) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.node.collection.id });

  return (
    <CollectionRow
      {...props}
      sortable={{
        setNodeRef,
        style: { transform: CSS.Transform.toString(transform), transition },
        isDragging,
        handleProps: { ...attributes, ...listeners },
      }}
    />
  );
}
